"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = require("../../styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles2 = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Highlight = function Highlight(_ref) {
  var children = _ref.children,
      isActive = _ref.isActive,
      classes = _ref.classes,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["children", "isActive", "classes", "color"]);

  return _react["default"].createElement("div", _extends({
    className: classes.root
  }, props), children, _react["default"].createElement("div", {
    className: classes.highlight
  }));
};

Highlight.defaultProps = {
  classes: {},
  color: _styles.colors.orange,
  isActive: true
};
Highlight.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string.isRequired).isRequired,

  /** The color of the highlight. The color will be filtered with opacity, so it will appear lighter than usual */
  color: _propTypes["default"].string,

  /** Whether or not the highligh is 'active'. When not active, the highlight will be at 0% opacity */
  isActive: _propTypes["default"].bool
};

var _default = (0, _withStyles["default"])(_styles2["default"])(Highlight);

exports["default"] = _default;